<template>
    <div>
        <form @submit.prevent="onSubmit" id="submit_form">
            <div class="row">
                <div class="col-12 col-md-6 my-2">
                    <label for="selected_gateway" v-text="$t('label.set_dedicated_gateway')"></label>
                    <select class="form-control kt-selectpicker" id="selected_gateway" name="selected_gateway"
                            v-model="form_data.selected_gateway">
                        <option :key="index" :value="gateway.id"
                                v-for="(gateway, index) in gateways"
                                v-text="gateway.farsi_name"
                        >
                        </option>
                    </select>
                </div>

                <div class="col-12 col-md-6 my-2">
                    <label for="selected_ivr_gateway" v-text="$t('label.set_ivr_gateway')"></label>
                    <select class="form-control kt-selectpicker" id="selected_ivr_gateway" name="selected_ivr_gateway"
                            v-model="form_data.selected_ivr_gateway">
                        <option :key="index" :value="gateway.id"
                                v-for="(gateway, index) in active_ivrs"
                                v-text="gateway.farsi_name"
                        >
                        </option>
                    </select>
                </div>

                <div class="col-12 h5 mt-4 mb-2" v-text="$t('label.service_provider_wage')"></div>

                <div class="col-12 col-md-6 my-2">
                    <label for="wage_type" v-text="$t('label.wage_type')"></label>
                    <select class="form-control" id="wage_type" name="wage_type" v-model="form_data.wage_type">
                        <!-- NOTE: we didnt use v-for cuz we shouldn't include SAME_AS_GLOBAL here -->
                        <option v-text="walletWageTypeStr.get(walletWageType.CONSTANT)"
                                :value="walletWageType.CONSTANT"
                        >
                        </option>
                        <option v-text="walletWageTypeStr.get(walletWageType.PERCENT)"
                                :value="walletWageType.PERCENT"
                        >
                        </option>
                        <option v-text="walletWageTypeStr.get(walletWageType.LIMITED_PERCENT)"
                                :value="walletWageType.LIMITED_PERCENT"
                        >
                        </option>
                    </select>
                </div>

                <div v-if="form_data.wage_type === walletWageType.LIMITED_PERCENT
                                || form_data.wage_type === walletWageType.PERCENT"
                     class="col-12 col-md-6 my-2">
                    <label for="wage_percent" v-text="$t('label.wage_percent')"></label>
                    <input class="form-control"
                           dir="ltr"
                           id="wage_percent"
                           name="wage_percent"
                           v-model="form_data.wage_percent"
                    >
                </div>

                <div v-if="form_data.wage_type === walletWageType.CONSTANT
                                || form_data.wage_type === walletWageType.LIMITED_PERCENT"
                     class="col-12 col-md-6 my-2">
                    <label for="wage_amount"
                           v-text="form_data.wage_type === walletWageType.LIMITED_PERCENT ?
                                        $t('label.max_wage') : $t('label.wage_amount')"
                    >
                    </label>
                    <input class="form-control"
                           dir="ltr"
                           id="wage_amount"
                           name="wage_amount"
                           v-model="form_data.wage_amount"
                    >
                </div>

                <div v-if="form_data.wage_type === walletWageType.LIMITED_PERCENT"
                     class="col-12 col-md-6 my-2">
                    <label for="min_wage_amount" v-text="$t('label.min_wage_amount')"></label>
                    <input class="form-control"
                           dir="ltr"
                           id="min_wage_amount"
                           name="min_wage_amount"
                           v-model="form_data.min_wage_amount"
                    >
                </div>

                <div class="col-12 h5 mt-4 mb-2" v-text="$t('label.paystar_wage')"></div>

                <div class="col-12 col-md-6 my-2">
                    <label for="paystar_wage_type" v-text="$t('label.wage_type')"></label>
                    <select class="form-control" id="paystar_wage_type" name="paystar_wage_type" v-model="form_data.paystar_wage_type">
                        <!-- NOTE: we didnt use v-for cuz we shouldn't include SAME_AS_GLOBAL here -->
                        <option v-text="walletWageTypeStr.get(walletWageType.CONSTANT)"
                                :value="walletWageType.CONSTANT"
                        >
                        </option>
                        <option v-text="walletWageTypeStr.get(walletWageType.PERCENT)"
                                :value="walletWageType.PERCENT"
                        >
                        </option>
                        <option v-text="walletWageTypeStr.get(walletWageType.LIMITED_PERCENT)"
                                :value="walletWageType.LIMITED_PERCENT"
                        >
                        </option>
                    </select>
                </div>

                <div v-if="form_data.paystar_wage_type === walletWageType.LIMITED_PERCENT
                                || form_data.paystar_wage_type === walletWageType.PERCENT"
                     class="col-12 col-md-6 my-2">
                    <label for="paystar_wage_percent" v-text="$t('label.wage_percent')"></label>
                    <input class="form-control"
                           dir="ltr"
                           id="paystar_wage_percent"
                           name="paystar_wage_percent"
                           v-model="form_data.paystar_wage_percent"
                    >
                </div>

                <div v-if="form_data.paystar_wage_type === walletWageType.CONSTANT
                                || form_data.paystar_wage_type === walletWageType.LIMITED_PERCENT"
                     class="col-12 col-md-6 my-2">
                    <label for="paystar_wage_amount"
                           v-text="form_data.paystar_wage_type === walletWageType.LIMITED_PERCENT ?
                                        $t('label.max_wage') : $t('label.wage_amount')"
                    >
                    </label>
                    <input class="form-control"
                           dir="ltr"
                           id="paystar_wage_amount"
                           name="paystar_wage_amount"
                           v-model="form_data.paystar_wage_amount"
                    >
                </div>

                <div v-if="form_data.paystar_wage_type === walletWageType.LIMITED_PERCENT"
                     class="col-12 col-md-6 my-2">
                    <label for="paystar_min_wage_amount" v-text="$t('label.min_wage_amount')"></label>
                    <input class="form-control"
                           dir="ltr"
                           id="paystar_min_wage_amount"
                           name="paystar_min_wage_amount"
                           v-model="form_data.paystar_min_wage_amount"
                    >
                </div>

                <div class="col-12 mt-4">
                    <button class="btn btn-success" type="submit" v-text="form_meta_data.submit_btn_text"></button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import {i18n} from "@/plugins/i18n";
    import $ from "jquery";
    import {walletService} from "@/common/api.service";
    import {mapGetters} from "vuex";
    import {walletWageTypeStr, walletWageType} from "@/constants/WalletWageType";

    export default {
        data() {
            return {
                walletWageType,
                walletWageTypeStr,
                form_data: {
                    selected_gateway: null,
                    selected_ivr_gateway: null,
                    wage_type: walletWageType.CONSTANT,
                    wage_percent: 0,
                    wage_amount: 0,
                    min_wage_amount: 0,
                    paystar_wage_type: walletWageType.CONSTANT,
                    paystar_wage_percent: 0,
                    paystar_wage_amount: 0,
                    paystar_min_wage_amount: 0,
                },
                form_meta_data: {
                    submit_btn_progress: false,
                    submit_btn_text: i18n.t('btn.submit_changes'),
                },
            };
        },
        computed: {
            ...mapGetters('collective', [
                'gateways',
            ]),
            ...mapGetters('ivr', [
                'active_ivrs',
            ]),
        },
        methods: {
            onSubmit() {
                let form = $('#submit_form');

                form.validate({
                    rules: {
                        selected_gateway: {
                            required: true,
                        },
                        selected_ivr_gateway: {
                            required: true,
                        },

                        wage_type: {
                            required: true,
                        },
                        wage_percent: {
                            required: () => {
                                return this.form_data.wage_type === walletWageType.PERCENT
                                    || this.form_data.wage_type === walletWageType.LIMITED_PERCENT;
                            },
                        },
                        wage_amount: {
                            required: () => {
                                return this.form_data.wage_type === walletWageType.CONSTANT
                                    || this.form_data.wage_type === walletWageType.LIMITED_PERCENT;
                            },
                        },
                        min_wage_amount: {
                            required: () => {
                                return this.form_data.wage_type === walletWageType.LIMITED_PERCENT;
                            },
                        },

                        paystar_wage_type: {
                            required: true,
                        },
                        paystar_wage_percent: {
                            required: () => {
                                return this.form_data.paystar_wage_type === walletWageType.PERCENT
                                    || this.form_data.paystar_wage_type === walletWageType.LIMITED_PERCENT;
                            },
                        },
                        paystar_wage_amount: {
                            required: () => {
                                return this.form_data.paystar_wage_type === walletWageType.CONSTANT
                                    || this.form_data.paystar_wage_type === walletWageType.LIMITED_PERCENT;
                            },
                        },
                        paystar_min_wage_amount: {
                            required: () => {
                                return this.form_data.paystar_wage_type === walletWageType.LIMITED_PERCENT;
                            },
                        },
                    }
                });

                if (!form.valid()) {
                    return;
                }

                this.form_meta_data.submit_btn_progress = true;

                let params = {
                    wallet_prefix: 'D',

                    selected_gateway: this.form_data.selected_gateway,
                    selected_ivr_gateway: this.form_data.selected_ivr_gateway,

                    wage_type: this.form_data.wage_type,
                    wage_percent: this.form_data.wage_percent,
                    wage_amount: this.form_data.wage_amount,
                    min_wage_amount: this.form_data.min_wage_amount,

                    paystar_wage_type: this.form_data.paystar_wage_type,
                    paystar_wage_percent: this.form_data.paystar_wage_percent,
                    paystar_wage_amount: this.form_data.paystar_wage_amount,
                    paystar_min_wage_amount: this.form_data.paystar_min_wage_amount,
                };

                walletService.setGlobalSettings(params).then(response => {
                    this.showMsg(form, 'success', response.data.message);
                }).catch(({response}) => {
                    if (response.data) {
                        form.validate().showErrors(response.data.data);
                    }

                    this.showMsg(form, 'danger', response.data.message);
                }).finally(() => {
                        this.form_meta_data.submit_btn_progress = false;
                    }
                );
            },
            initSelectPicker() {
                setTimeout(() => {
                    $('.kt-selectpicker').selectpicker({
                        size: 4,
                        liveSearch: true,
                        noneResultsText: i18n.t('selectpicker.none_result'),
                        selectAllText: i18n.t('selectpicker.select_all'),
                        noneSelectedText: i18n.t('selectpicker.nothing_selected')
                    })
                }, 1000);
            },
        },
        mounted() {
            this.$store.dispatch('collective/fetch').then(() => {
                this.$store.dispatch('ivr/fetch').then(() => {
                    let params = {
                        wallet_prefix: 'D',
                    };

                    walletService.getGlobalSettings(params).then(response => {
                        this.form_data = response.data.data;
                        this.initSelectPicker();
                    });
                });
            });
        },
    }
</script>
